var $fcda0e0582088650$exports = {};
$fcda0e0582088650$exports = {
  "help": "\u017Dinynas",
  "info": "Informacija"
};
export { $fcda0e0582088650$exports as default };